import * as React from "react";
import MainCategory from "./MainCategory";

const MainCategories = ({items: categories, selectedItem, setSelectedItem, inAnimation, setInAnimation}) => {
  return (
    <div className={'mt-1'}>
      <div className={'w-full relative overflow-x-auto whitespace-nowrap no-scrollbar px-[25px] flex h-[130px]'}>
        {categories && (
          categories.map(category => {
            return (
              <div className={'w-[100px] m-[5px] '} onClick={() => {
                if (!inAnimation && category !== selectedItem) {
                  setSelectedItem(category)
                  setInAnimation(true)
                }
              }}
                   key={'category-' + category.id}>
                <MainCategory category={category}/>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
export default MainCategories;
